<template>
    <div class="block24">
            <!-- 返回 -->
            <div class="return">
              <router-link to="/"><span class="arrow"></span>返回首页</router-link>
            </div>
            <!-- 返回 -->
            <!-- 内容 -->
            <div class="container">
              <h2 class="title1">侧支架</h2>
              <div class="container-content">
                <p class="text_line">检查侧支架</p>
                <img src="./img/img1.jpg" width="100%">
                <ul class="numberspace">
                  <li>
                    <em>1</em>检查侧支架是否能顺畅工作。如果侧支架僵硬或发出异响，请清洁枢轴区域并用干净的润滑脂润滑枢轴螺栓
                  </li>
                  <li>
                    <em>2</em>检查弹簧有无损坏或弹性是否丧失
                  </li>
                </ul>
                
              </div>
              <div class="foot-btn">
                <div class="prev">
                  <router-link to="/block23">上一页</router-link>
                </div>
                <div class="next">
                  <router-link to="/block25">下一页</router-link>
                </div>
              </div>
            </div>
        </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>